import React from "react"
import { useTranslation } from "react-i18next"
import FeedbackForm from "../component/sections/FeedBackForm"

const Feedback = () => {
  const { t } = useTranslation()

  return (
    <>
      <section className="mx-auto max-w-7xl p-8 bg-blue-100">
        <h1 className="text-2xl md:text-4xl font-semibold mb-4">
          {t("feedback.title")}
        </h1>
        <p className="text-lg md:text-xl text-gray-600">
          {t("feedback.subtitle")}
        </p>
      </section>
      <FeedbackForm />
    </>
  )
}

export default Feedback
